export var TEXT              = 1;
export var INTERPOLATOR      = 2;
export var TRIPLE            = 3;
export var SECTION           = 4;
export var INVERTED          = 5;
export var CLOSING           = 6;
export var ELEMENT           = 7;
export var PARTIAL           = 8;
export var COMMENT           = 9;
export var DELIMCHANGE       = 10;
export var ANCHOR            = 11;
export var ATTRIBUTE         = 13;
export var CLOSING_TAG       = 14;
export var COMPONENT         = 15;
export var YIELDER           = 16;
export var INLINE_PARTIAL    = 17;
export var DOCTYPE           = 18;
export var ALIAS             = 19;

export var NUMBER_LITERAL    = 20;
export var STRING_LITERAL    = 21;
export var ARRAY_LITERAL     = 22;
export var OBJECT_LITERAL    = 23;
export var BOOLEAN_LITERAL   = 24;
export var REGEXP_LITERAL    = 25;

export var GLOBAL            = 26;
export var KEY_VALUE_PAIR    = 27;


export var REFERENCE         = 30;
export var REFINEMENT        = 31;
export var MEMBER            = 32;
export var PREFIX_OPERATOR   = 33;
export var BRACKETED         = 34;
export var CONDITIONAL       = 35;
export var INFIX_OPERATOR    = 36;

export var INVOCATION        = 40;

export var SECTION_IF        = 50;
export var SECTION_UNLESS    = 51;
export var SECTION_EACH      = 52;
export var SECTION_WITH      = 53;
export var SECTION_IF_WITH   = 54;

export var ELSE              = 60;
export var ELSEIF            = 61;

export var EVENT             = 70;
export var DECORATOR         = 71;
export var TRANSITION        = 72;
export var BINDING_FLAG      = 73;
export var DELEGATE_FLAG     = 74;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/config/types.js.map
